import React from "react";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../utils/analytics";
function BuyBox({
  product,
  selectedCondition,
  selectedVariant
}) {




  
  const navigate = useNavigate();

const price =
  selectedVariant?.price ??
  product?.price ??
  0;

const dollars = Math.floor(price);

const cents = (price % 1)
  .toFixed(2)
  .substring(2);


const today = new Date();
const startDelivery = new Date(today); startDelivery.setDate(today.getDate() + 3);
const endDelivery = new Date(today); endDelivery.setDate(today.getDate() + 4);
const deliveryStart = startDelivery.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
const deliveryEnd = endDelivery.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" });
const fallbackDelivery = `${deliveryStart} – ${deliveryEnd}`;

    const [quantity, setQuantity] = React.useState(1);
const [cartSuccess, setCartSuccess] = React.useState(false);
const [cartError, setCartError] = React.useState("");
const [zip, setZip] = React.useState(() => localStorage.getItem("deliveryZip") || "");
const [zipInput, setZipInput] = React.useState("");
const [showZipInput, setShowZipInput] = React.useState(false);

const outOfStock = !selectedVariant || selectedVariant.stock <= 0;

const handleOrderNow = async () => {
  if (!product?.listingId) return;

  const finalPrice = selectedVariant?.price ?? product?.price;

  if (!finalPrice || isNaN(finalPrice)) {
    alert("Invalid product price");
    return;
  }

  try {
    const cartRes = await fetch("https://eleven11-i6v4.onrender.com/api/cart");
    const cartData = await cartRes.json();
    const alreadyInCart = (cartData.items || []).some(
      item => item.listingId === product.listingId &&
               item.selectedCondition === selectedCondition
    );

    if (!alreadyInCart) {
      await fetch("https://eleven11-i6v4.onrender.com/api/cart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          productId: product.listingId,
          qty: quantity,
          selectedCondition,
          selectedVariant,
          price: finalPrice
        })
      });
    }

    navigate("/checkout", {
      state: {
        product,
        quantity,
        selectedCondition,
        selectedVariant,
        price: finalPrice,
        listingId: product?.listingId,
        title: product?.title,
        image: product?.image
      }
    });

  } catch (error) {
    console.error("Order now error:", error);
  }
};


  return (
    <div style={styles.wrapper}>

      {/* TOP SECTION */}
      <div style={styles.topBox}>

     <div style={styles.buyNew}>
  {selectedVariant?.label || "Select Option"}:
</div>

        <div style={styles.priceRow}>
         <span style={styles.priceDollar}>$</span>
<span style={styles.priceMain}>{dollars}</span>
<span style={styles.priceCents}>{cents}</span>
          <span style={styles.priceUnit}> </span>
        </div>

       <div style={styles.deliveryBlock}>

  <div style={styles.deliveryRow}>
    <span style={styles.deliveryLabel}>FREE delivery</span>
<span style={styles.deliveryDate}>{product.delivery || fallbackDelivery}</span>
  </div>

  <div style={styles.fastRow}>
    <span style={styles.lightning}></span>
    <span style={styles.fastText}>
Fastest delivery <b>{product.fastest || deliveryStart}</b>
    </span>
  </div>

  <div style={styles.locationRow}>
    <span style={styles.locationLabel}>Delivering to</span>
    <span style={styles.locationZip}>{zip || "your location"}</span>
    <span style={styles.link} onClick={() => { setZipInput(zip); setShowZipInput(v => !v); }}>Update</span>
  </div>
  {showZipInput && (
    <div style={{ display: "flex", gap: 6, marginTop: 8 }}>
      <input
        value={zipInput}
        onChange={e => setZipInput(e.target.value)}
        placeholder="Enter ZIP code"
        maxLength={5}
        style={{ flex: 1, padding: "8px 12px", borderRadius: 10, border: "1px solid #ddd", fontSize: 14, outline: "none" }}
        onKeyDown={e => {
          if (e.key === "Enter" && zipInput.length === 5) {
            setZip(zipInput);
            localStorage.setItem("deliveryZip", zipInput);
            setShowZipInput(false);
          }
        }}
      />
      <button
        onClick={() => {
          if (zipInput.length === 5) {
            setZip(zipInput);
            localStorage.setItem("deliveryZip", zipInput);
            setShowZipInput(false);
          }
        }}
        style={{ padding: "8px 14px", borderRadius: 10, border: "none", background: "#0f0f17", color: "#fff", fontSize: 13, fontWeight: 700, cursor: "pointer" }}
      >
        Save
      </button>
    </div>
  )}


</div>

   <div style={styles.stock}>
{selectedVariant?.stock > 0
  ? "In Stock"
  : "Out of Stock"}
</div>

<div style={styles.stockDivider}></div>

    <div style={styles.qtyWrapper}>

  <span style={styles.qtyLabel}>Quantity</span>

  <div style={styles.qtyStepper}>

    <button
      style={styles.qtyButton}
      onClick={() => quantity > 1 && setQuantity(quantity - 1)}
    >
      −
    </button>

    <span style={styles.qtyNumber}>
      {quantity}
    </span>

    <button
      style={styles.qtyButton}
     onClick={() => quantity < (selectedVariant?.stock || 1) && setQuantity(quantity + 1)}
    >
      +
    </button>

  </div>

</div>
        {/* BUTTONS */}

        
<button
  style={{ ...styles.buyNow, ...(outOfStock ? { opacity: 0.4, cursor: "not-allowed", background: "#ccc" } : {}) }}
  onClick={outOfStock ? undefined : handleOrderNow}
  disabled={outOfStock}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = "translateY(-3px)";
    e.currentTarget.style.boxShadow =
      "0 18px 38px rgba(20,173,255,0.45), 0 8px 18px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.35)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow =
      "0 10px 20px rgba(20,173,255,0.35), inset 0 1px 0 rgba(255,255,255,0.25)";
  }}
>
  Order Now
</button>

{cartError && (
  <div style={{
    background: "#FEF2F2",
    color: "#DC2626",
    fontSize: 13,
    fontWeight: 700,
    padding: "8px 14px",
    borderRadius: 10,
    marginBottom: 8,
    textAlign: "center"
  }}>
    ⚠ {cartError}
  </div>
)}
{cartSuccess && (
  <div style={{
    background: "#EDFDF4",
    color: "#15803D",
    fontSize: 13,
    fontWeight: 700,
    padding: "8px 14px",
    borderRadius: 10,
    marginBottom: 8,
    textAlign: "center"
  }}>
    ✓ Added to cart
  </div>
)}
        
<button
  style={{ ...styles.addCart, ...(outOfStock ? { opacity: 0.4, cursor: "not-allowed", background: "#ccc" } : {}) }}
  disabled={outOfStock}
  onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-3px)";
  e.currentTarget.style.boxShadow =
    "0 18px 38px rgba(20,173,255,0.45), 0 8px 18px rgba(0,0,0,0.12), inset 0 1px 0 rgba(255,255,255,0.35)";
}}
onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow =
    "0 10px 20px rgba(20,173,255,0.35), inset 0 1px 0 rgba(255,255,255,0.25)";
}}
 onClick={outOfStock ? undefined : async () => {
    if (!product?.listingId) return;
    const finalPrice = selectedVariant?.price ?? product?.price;
    if (!finalPrice || isNaN(finalPrice)) return;
    try {
      const res = await fetch("https://eleven11-i6v4.onrender.com/api/cart", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          productId: product.listingId,
          qty: quantity,
          selectedCondition,
          selectedVariant,
          price: finalPrice
        })
      });
      const data = await res.json();
      if (!res.ok) {
        setCartError(data.error || "Could not add to cart");
        setTimeout(() => setCartError(""), 3000);
        return;
      }
      trackEvent("add_to_cart", {
        listingId: product.listingId,
        listingTitle: product.title
      });
      setCartSuccess(true);
      setTimeout(() => setCartSuccess(false), 2000);
    } catch (error) {
      console.error("Add to cart error:", error);
      setCartError("Could not add to cart");
      setTimeout(() => setCartError(""), 3000);
    }
  }}
>
  Add to Cart
</button>



<button style={{
  ...styles.shopPay,
  opacity: 0.5,
  cursor: "not-allowed",
  background: "#f5f7fa",
  border: "1px solid #E6EAF0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 8
}} disabled>
  <img
    src="https://cdn.brandfetch.io/idhmgMczrJ/w/180/h/40/theme/dark/logo.png?c=1id1BYqG0lAP4fYvUiK"
    alt="Affirm"
    style={{ height: 22, objectFit: "contain", filter: "grayscale(1)", opacity: 0.5 }}
    onError={e => { e.target.style.display = "none"; }}
  />
  <span style={{ fontSize: 15, fontWeight: 700, color: "#9CA3AF" }}>Affirm</span>
</button>

<div style={styles.shopText}>
  Buy Now Pay Over Time — Coming Soon
</div>
{/* DETAILS */}

<div style={styles.sellerDivider}>
  <div style={styles.dividerLine}></div>

  <span style={styles.dividerText}>ELEVEN</span>

  <div style={styles.dividerLine}></div>
</div>

</div> {/* ✅ CLOSE topBox HERE */}

{/* USED BOX */}
<div style={{
  ...styles.usedBox,
  padding: "16px 18px",
  background: "#f9f9fb"
}}>
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
    <div style={{ fontSize: 13, fontWeight: 700, color: "#2F3441" }}>
      Local Pickup · FACILITY ELEVEN
    </div>
    <span style={{
      fontSize: 10,
      fontWeight: 700,
      padding: "3px 10px",
      borderRadius: 999,
      background: "#EDEDF0",
      color: "#9CA3AF",
      letterSpacing: 0.8,
      flexShrink: 0,
      marginLeft: 10
    }}>
      COMING SOON
    </span>
  </div>
  <div style={{ fontSize: 12, color: "#B0B7C3", lineHeight: "17px" }}>
    Pick up at FACILITY ELEVEN or an Authorized Dealer near you.
  </div>
</div>
    </div>

  );
}

const styles = {



deliveryBlock:{
  marginBottom:14,
  display:"flex",
  flexDirection:"column",
  gap:8
},

deliveryRow:{
  display:"flex",
  flexDirection:"column",
  fontSize:14
},

shopPay:{
  width:"100%",
  padding:12,
  borderRadius:25,
  border:"1px solid #E6EAF0",
  background:"#ffffff",
  color:"#010006ff",
  fontWeight:600,
  fontSize:16,
  marginTop:10,
  cursor:"pointer",

  transition:"all .18s ease",

  boxShadow:"0 4px 10px rgba(0,0,0,0.05)"
},
shopLogo:{
  fontWeight:700,
  marginRight:4
},

shopText:{
  fontSize:12,
  color:"#6B7280",
  textAlign:"center",
  marginTop:6
},


deliveryLabel:{
  color:"#111",
  fontWeight:500
},

deliveryDate:{
  fontWeight:600,
  marginLeft:20
},

fastRow:{
  display:"flex",
  alignItems:"center",
  gap:6,
  fontSize:13,
  color:"#565959"
},

lightning:{
  fontSize:14
},

fastText:{
  color:"#565959"
},

locationRow:{
  display:"flex",
  alignItems:"center",
  gap:6,
  fontSize:13,
  marginTop:8
},

locationLabel:{
  color:"#565959"
},

locationZip:{
  fontWeight:500
},









 wrapper: {
  width: 320,
  fontFamily: "-apple-system, BlinkMacSystemFont, system-ui",
  boxShadow: "0 6px 14px rgba(0,0,0,0.08)",
  borderRadius: 20,
  overflow: "hidden"
},
  topBox: {
  border: "1px solid #ddd",
  borderRadius: "20px 20px 0 0",
  padding: 18,
},

stockDivider:{
  height:1,
  background:"#E6EAF0",
  margin:"12px 0"
},

qtyWrapper:{
  marginTop:10,
  marginBottom:10,
  display:"flex",
  alignItems:"center",
  justifyContent:"space-between"
},

qtyLabel:{
  fontSize:13,
  color:"#6E7385",
  fontWeight:500
},

qtyStepper:{
  display:"flex",
  alignItems:"center",
  justifyContent:"space-between",
  width:"100%",
  maxWidth:140,
  padding:"4px",
  borderRadius:14,

  background:"#F5F7FB",

  border:"1px solid #E4E8F0",

  boxShadow:"inset 0 1px 0 rgba(255,255,255,0.7)"
},
qtyButton:{
  width:32,
  height:32,
  borderRadius:10,
  border:"none",
  fontSize:18,
  fontWeight:500,
  cursor:"pointer",

  background:"#FFFFFF",

  boxShadow:"0 2px 4px rgba(0,0,0,0.08)",

  transition:"all .15s ease"
},

qtyNumber:{
  fontSize:17,
  fontWeight:600,
  color:"#2F3441",
  width:28,
  textAlign:"center"
},


sellerDivider:{
  display:"flex",
  alignItems:"center",
  gap:12,
  marginTop:30,
  marginBottom:18
},

dividerLine:{
  flex:1,
  height:1,
 background:"#D8DCE3"
},

dividerText:{
  fontSize:18,
  letterSpacing:2,
  color:"#9AA1B2",
  fontWeight:500
},


detailsSection: {
  marginTop: 18
},

fastest: {
  fontSize: 14,
  color: "#565959",
  marginBottom: 12
},

  usedBox: {
    border: "1px solid #ddd",
    borderTop: "none",
    borderRadius: "0 0 8px 8px",
    padding: 18,
    background: "#eeeeeeff"
  },

  buyNew: {
    fontWeight: 600,
    marginBottom: 10
  },

  priceRow: {
    display: "flex",
    alignItems: "baseline",
    marginBottom: 12
  },

  priceDollar: {
    fontSize: 14
  },

  priceMain: {
    fontSize: 34,
    fontWeight: 500
  },

  priceCents: {
    fontSize: 18,
    marginLeft: 2
  },

  priceUnit: {
    fontSize: 14,
    marginLeft: 6,
    color: "#565959"
  },

  delivery: {
  fontSize: 15,
  marginBottom: 4
},

  primeText: {
    fontSize: 14,
    marginBottom: 12
  },

  location: {
    fontSize: 14,
    marginBottom: 14
  },

  link: {
    color: "#007185",
    cursor: "pointer"
  },

  green: {
    color: "#007600"
  },

  stock: {
    color: "#05b4ffff",
    fontSize: 18,
    marginBottom: 10
  },

  qty: {
    width: "100%",
    padding: 10,
    borderRadius: 8,
    border: "1px solid #ccc",
    marginBottom: 12
  },

 addCart: {
  width: "100%",
  padding: 12,
  borderRadius: 25,
  border: "none",
  background: "linear-gradient(180deg,#5a8efc,#1f57c8)",
  color: "#ffffff",
  fontWeight: 600,
  fontSize: 16,
  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
  marginBottom: 8,
  cursor: "pointer",
  transition: "all .18s ease",
  boxShadow: "0 10px 20px rgba(20,173,255,0.35), inset 0 1px 0 rgba(255,255,255,0.25)"
},


buyNow: {
  width: "100%",
  padding: 12,
  borderRadius: 25,
  border: "none",
 background: "linear-gradient(180deg,#5a8efc,#1f57c8)",
  color: "#ffffffff",
  fontWeight: 600,
  fontSize: 16,
  fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
  marginTop: 12,
  marginBottom: 14,
  cursor: "pointer",
  transition: "all .18s ease",
  boxShadow:
    "0 10px 20px rgba(20,173,255,0.35), inset 0 1px 0 rgba(255,255,255,0.25)"
},
  detailRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 14,
    marginBottom: 8
  },

  detailLabel: {
    color: "#565959"
  },

  checkbox: {
    fontSize: 14,
    marginTop: 10,
    display: "block"
  },

  usedTitle: {
    fontWeight: 600,
    marginBottom: 10
  },

  smallText: {
    fontSize: 14,
    marginTop: 6
  }

};

export default BuyBox;